import styled from '@emotion/styled';
import React from 'react';
import JSXProduction from 'react/jsx-runtime';
import rehypeParse from 'rehype-parse';
import rehypeReact, { Options } from 'rehype-react';
import { unified } from 'unified';

const MobileLineBreak = styled.br({
  '@media (min-width: 40em)': {
    display: 'none',
  },
});

export const selfClosingWrapper = (element: React.ReactNode) => (props: React.PropsWithChildren) => (
  <>
    {element}
    {props.children}
  </>
);

export type ReplaceComponentType = (props: React.PropsWithChildren) => React.ReactNode;
const components = { span: selfClosingWrapper(<span />), mbr: selfClosingWrapper(<MobileLineBreak />) };

export function processJSXText(text: string, _components: Record<string, ReplaceComponentType> = {}) {
  const processor = unified()
    .use(rehypeParse, { fragment: true })
    .use(rehypeReact, {
      ...(JSXProduction as Options),
      components: { ...components, ..._components } as Options['components'],
    });

  return processor.processSync(text).result as React.ReactNode;
}
